$(document).ready(function() {
  // Restrict input to digits only
  $('.number').on('input', function(e) {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  });

  // Function to show validation modal with a custom message
  function showValidationModal(message) {
    $('#validationModal .modal-body').text(message);
    $('#validationModal').modal('show');
  }
});
